module.exports = __webpack_public_path__ + "img/black38.33618ae3.png";